import type { TokenUsageRow } from '@app/services/api.types';


export const normalizeTokenUsage = (nodes: TokenUsageRow[] = []): TokenUsageRow[] => {
    if (!nodes.length) {
        return [];
    }

    // Already nested by the API — nothing to do.
    if (nodes.some((node) => node.children?.length)) {
        return nodes;
    }

    const roots: TokenUsageRow[] = [];
    const groups = new Map<string, TokenUsageRow[]>();

    nodes.forEach((node) => {
        if (node.parent_id) {
            const bucket = groups.get(node.parent_id);
            if (bucket) {
                bucket.push(node);
            } else {
                groups.set(node.parent_id, [node]);
            }
        } else {
            // Standalone location (no parent) — a root row on its own.
            roots.push(node);
        }
    });

    groups.forEach((children, parentId) => {
        const sortedChildren = [...children].sort((a, b) => a.name.localeCompare(b.name));
        const callTokens = sortedChildren.reduce((sum, c) => sum + c.call_tokens_used, 0);
        const waTokens = sortedChildren.reduce((sum, c) => sum + c.whatsapp_tokens_used, 0);
        const cap = sortedChildren.reduce((sum, c) => sum + c.monthly_token_cap, 0);

        roots.push({
            id: `parent-${parentId}`,
            name: sortedChildren[0].parent_name || 'Unknown branch',
            monthly_token_cap: cap,
            call_tokens_used: callTokens,
            whatsapp_tokens_used: waTokens,
            total_tokens_used: callTokens + waTokens,
            children: sortedChildren,
        });
    });

    return roots.sort((a, b) => a.name.localeCompare(b.name));
};
